import Helmet from '@plone/volto/helpers/Helmet/Helmet';

interface JsonLdProps {
  data: unknown;
  id?: string;
}

const JsonLd = ({ data, id }: JsonLdProps) => (
  <Helmet>
    <script
      type="application/ld+json"
      {...(id ? { 'data-jsonld-id': id } : {})}
    >
      {JSON.stringify(data)}
    </script>
  </Helmet>
);

export default JsonLd;
